import {getLocalStorage} from "../util/localStorage.util";
import axios from 'axios';
import {ACCESS_KEY, GraphACCESS_KEY, USER_KEY} from "../constants";
import config from '../config/config';

export const httpBase = (isV2Api:boolean,isSharePoint:boolean,isV3Api:any,isOctate:any) => {
    const shareUrl = `${config.sharePointBaseUrl}`;
    const baseURL3001 = `${config.globalTraitServiceUrl}`;
    const v2BaseUrl = `${config.planningServiceURL}`;
    const v3BaseUrl =`${config.DYNAMIC_PAGE_BASE_URL}`;
    const userId = `${getLocalStorage(USER_KEY)}`
    const normalHeaders = {
        Accept: 'application/json',
        Authorization: `Bearer ${getLocalStorage(USER_KEY)}`,
        'Content-Type': 'application/json',
    };
    const V2Headers = {
        Accept: 'application/json, text/plain, */*',
        Authorization: `Bearer ${getLocalStorage(USER_KEY)}`,
        'Content-Type': 'application/json',

    };
    const SharepointHeaders = {
        Accept: "*/*;odata=verbose",
        Authorization: `Bearer ${getLocalStorage(GraphACCESS_KEY)}`,
        'Content-Type': 'text/plain',
        withCredentials: true,
        Prefer:'HonorNonIndexedQueriesWarningMayFailRandomly'
    }

    const v3Headers = {
        Accept: '*/*',
        Authorization: `Bearer ${getLocalStorage(USER_KEY)}`,
        'Content-type': 'multipart/form-data'
    }

    const isOctateHeaders ={
        Accept: '*/*',
        Authorization: `Bearer ${getLocalStorage(USER_KEY)}`,
        "Content-Type": "binary/octet-stream",
    }


    const api = axios.create({
            baseURL:isSharePoint ?shareUrl : isV2Api === true ? `${v2BaseUrl}` :isV3Api ?`${v3BaseUrl}` : `${baseURL3001}`,
            headers: isSharePoint ? {...SharepointHeaders}: isV2Api === true ? { ...V2Headers }:(isV3Api && isOctate !== true) ? {...v3Headers} :
                (isV3Api && isOctate === true) ?  {...isOctateHeaders}:
                    { ...V2Headers },
            responseType: isOctate ? 'blob':'json',
        }

    );

    api.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (401 === error.response.status) {
                console.log(error, '401')
            }
            if (404 === error.response.status) {
                console.log(error, '404')
            }
            if (500 === error.response.status) {
                console.log(error, '500')
            }
            return Promise.reject(JSON.stringify(error));
        }
    );

    return api;
};
// export default httpBase;
